/* esm.sh - lit-html@3.3.3/directives/when */
function t(e,n,r){return e?n(e):r?.(e)}export{t as when};
/*! Bundled license information:

lit-html/directives/when.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=when.mjs.map